import store from './store/index'

export const authInterceptor = (request, next) => {
  const token = localStorage.getItem('token')
  if (token) {
    request.headers.set('Authorization', 'Token ' + token)
  }

  //crsf-token
  const CSRFToken = getCookie('csrftoken')
  const urlWithOrigin = request.url && isAbsoluteURL(request.url) && request.url.indexOf(window.location.origin) === 0
  let rootWithOrigin = false
  if (!isAbsoluteURL(request.url)) {
    rootWithOrigin = !request.root || request.root === '/' || request.root.indexOf(window.location.origin) === 0
  }

  if (CSRFToken && (urlWithOrigin || rootWithOrigin)) {
    request.headers.set('X-CSRFToken', CSRFToken)
  }

  next()
}

export const errorInterceptor = (request, next) => {
  next((response) => {
    if (response.body && (response.body.detail || response.body.error || response.body.message) && response.status !== 200) {
      store.commit('setApiError', response.body)

      if (response.status === 403) {
        store.dispatch('logout')
      }
    }
  })
}

function getCookie(name) {
  let cookieValue = null
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  return cookieValue
}

function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url)
}



// WEBPACK FOOTER //
// ./src/interceptors.js